module.exports = __webpack_public_path__ + "static/media/th-large.c8d988f5.svg";